import TripDay from './TripDay';
import TripMonth from './TripMonth';
import css from './insights.less';
import Occasion from './Occasion';
import BillYearMonth from './BillYearMonth';
import NewVsReturningCustomers from './NewVsReturningCustomers';
import BookingsByVehicle from "./BookingsByVehicle";
import InsightsTotals from './InsightsTotals';
import QuoteRequestsSection from './QuoteRequests'

export default function InsightsReport() {

    return (
        <div className={css.root}>
            <InsightsTotals/>
            <BillYearMonth/>
            <NewVsReturningCustomers/>
            <TripDay/>
            <TripMonth/>
            <Occasion/>
            <BookingsByVehicle/>
            <QuoteRequestsSection/>
        </div>
    )
}
